import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";

import DataProtectionSoftwareService from "src/modules/data-protection/apis/DataProtectionSoftwareService";

import { unwrapEligibleAssignees } from "../helpers";

const useApprovalEligibleAssignees = ({
    softwareId,
    requirementId,
    enabled = false,
    t,
} = {}) => {
    const query = useQuery({
        queryKey: [
            "gdpr-software-approval-eligible-assignees",
            softwareId,
            requirementId,
        ],
        queryFn: async () => {
            const service = DataProtectionSoftwareService.getInstance();

            return unwrapEligibleAssignees(
                await service.fetchApprovalEligibleAssignees(
                    softwareId,
                    requirementId
                )
            );
        },
        enabled: Boolean(softwareId && requirementId && enabled),
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === "development") {
                console.error(error);
            }

            toast(t("An error occurred while fetching eligible users."), {
                type: "error",
            });
        },
    });

    return {
        users: query.data || [],
        isLoading: query.isLoading,
    };
};

export default useApprovalEligibleAssignees;
